import * as React from 'react';
import addViewportFitCover from '../utils/addViewportFitCover';
import cx from 'classnames/bind';
import getModuleSwitcherItems from '../utils/getModuleSwitcherItems';
import type Module from 'mini-common-schema/lib/schema/Module';
import type ModuleSwitcherItem from '../schema/ModuleSwitcherItem';
import onModuleSwitcherItemClick from '../utils/onModuleSwitcherItemClick';
import strings from 'owa-strings/owa-mini-common-strings';
import styles from './MiniModuleSwitcher.scss';
import { CalendarIconDefault } from 'mini-calendar-icon/lib/components/CalendarIconDefault';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';
import { isIOS } from 'mini-device-utils/lib/utils/isIOS';
import { observer } from 'mobx-react';
import type ModuleSwitcherProps from './ModuleSwitcherProps';

const classNames = cx.bind(styles);

@observer
export default class MiniModuleSwitcher extends React.Component<ModuleSwitcherProps, {}> {
    componentDidMount() {
        addViewportFitCover();
    }

    render() {
        const { iconRefs, currentModule, className } = this.props;

        return (
            <nav
                className={classNames(
                    styles.moduleSwitcher,
                    { [styles.iOSSafeArea]: isIOS() },
                    className
                )}
                role="heading"
                tabIndex={0}
                aria-level={1}
                aria-label={strings.moduleSwitcherFooterAriaLabel}>
                {getModuleSwitcherItems(iconRefs, currentModule).map(this.renderModuleSwitcherItem)}
            </nav>
        );
    }

    renderCalendarItem = (isSelected, iconRef) => {
        const { renderCalendarIcon = ref => <CalendarIconDefault ref={ref} /> } = this.props;
        return renderCalendarIcon(iconRef);
    };

    private renderModuleSwitcherItem = (item: ModuleSwitcherItem) => {
        const { currentModule, onActiveModuleClickAction } = this.props;
        const {
            moduleType,
            icon,
            label,
            ariaLabel,
            ariaLabelWhenSelected,
            iconRef,
            iconStyles,
            className,
            onModuleClick,
        } = item;
        const isSelected = moduleType === currentModule;
        const buttonClasses = classNames('moduleSwitcher-button', {
            'moduleSwitcher-button--selected': isSelected,
        });

        // Keeping Calendar icon code because it has campaign logic. Will remove in subsequent PRs.
        return (
            <div
                key={icon}
                className={classNames(buttonClasses, className)}
                onClick={() =>
                    onModuleSwitcherItemClick(
                        currentModule,
                        moduleType,
                        onActiveModuleClickAction,
                        onModuleClick
                    )
                }
                role="button"
                aria-label={isSelected ? ariaLabelWhenSelected : ariaLabel}
                tabIndex={0}>
                {moduleType === 1 ? (
                    this.renderCalendarItem(isSelected, iconRef)
                ) : (
                    <FluentSvgIcon
                        icon={icon}
                        iconStyles={iconStyles}
                        iconContainerStyles={styles.iconContainer}
                        ref={iconRef}
                    />
                )}
                <span className={styles.label}>{label}</span>
            </div>
        );
    };
}
